
import React from 'react'
//import './funcionesEspeciales.scss' 
export const Ruta = process.env.REACT_APP_RUTA_SISTEMA
export const RutaLocal = process.env.REACT_APP_RUTA_PRINCIPAL
export const RutaProductos = Ruta + "includes/img/"
//export const ENDPOINT = "http://localhost:4010";//ENDPOINT_SERVER_SOCKET
export const ENDPOINT = "http://3.138.242.205:4011";//ENDPOINT_SERVER_SOCKET
export const moneda_mostrar = "S/ "
export const cantidad_decimales_mostrar = 2
export const token = localStorage.getItem("token_web")


/*export const consultarTipoCambio = async () => {
    let tipo_cambio = 3.8
    await fetch(`${Ruta}web/getUltimoTipoCambio`, {
        headers: { 'Authorization': '3885a650df6f71611c630ea550f9be2eb12a882d7eddf3c95fb0bf4967ed1538d7246783db6db577a98aacf490ef70d1d398fc1a543ef80ea8f035ac3ec1df38', },
    })
        .then(response => response.json())
        .then(data => {
            tipo_cambio = data[0].tipo_cambio_venta
        })
    return tipo_cambio
}
export const tipo_cambio =  consultarTipoCambio()
//para utilizar essto necesitas el top level await TRUE
*/
export const TIPO_CAMBIO = async () => {
    return await fetch(`${Ruta}?/web/getUltimoTipoCambio`, {
        headers: { 'Authorization': '3885a650df6f71611c630ea550f9be2eb12a882d7eddf3c95fb0bf4967ed1538d7246783db6db577a98aacf490ef70d1d398fc1a543ef80ea8f035ac3ec1df38', },
    })
        .then(response => response.json())
        .catch(error => {
            console.log("error en API", error)
        })
}
//export const hola=TIPO_CAMBIO().then(response=>{return response[0].tipo_cambio_venta})
//export const ENDPOINT = "http://3.138.242.205:4001";//ENDPOINT_SERVER_SOCKET 

/*export const porcentajeIGV = async () => {
    let porcentaje_igv = 0;
    await fetch(`${Ruta}empresa_info/getIGV`)
        .then(response => response.json())
        .then(data => {
            porcentaje_igv = data[0].porcentaje_igv
        })
    return porcentaje_igv
}*/
export const porcentaje_igv = 18

export const cantidad_decimales_venta = 2;
export const renderNumero = (numero) => {
    let numero_parse = parseFloat(numero)
    numero_parse = numero_parse.toFixed(cantidad_decimales_venta)
    numero_parse = parseFloat(numero_parse)
    return new Intl.NumberFormat('es-Pe', { "minimumFractionDigits": 2 }).format(numero_parse)
}
export const calcularPrecioFinal = (numero, tipo_igv = 14, moneda = 12, tipo_cambio = 3.78) => {
    //tipo_igv{14:gravado,15:exonerado|moneda:12 soles,13:dolares}
    try {
        if (moneda != 12) {
            numero = numero * tipo_cambio
        }
        if (tipo_igv != 15) {
            numero = numero * (1 + (porcentaje_igv / 100))
        }
        numero = parseFloat(numero)
        return parseFloat(numero.toFixed(2))
    } catch (error) {
        console.error("error con el number: ", numero, error);
        return 0;
    }

}
export const codeNombreProductoURL = (nombre) => {
    let producto_cambio_guion = (nombre || "").replaceAll('-', ';;')
    let producto_cambio_signo_mas = (producto_cambio_guion || "").replaceAll('+', '||') //cambio el '+' por el '||' para el servidor pueda leer bien el + y no lo lea como espacio
    let producto_url = producto_cambio_signo_mas.replaceAll(' ', '-')
    return producto_url
}
export const decodeNombreProductoURL = (nombre) => {//ojo siempre deben codificar y decodificar el name para buscar bien en la BD
    //console.log("antes de", nombre)
    let nombre_parse = decodeURI((nombre || "").replaceAll('-', ' '));
    //let nombre_parse = (nombre || "").replaceAll('-', ' ');
    nombre_parse = nombre_parse.replaceAll(';;', '-');
    //nombre_parse = nombre_parse.replaceAll('||', '+');// este cambio lo hago en el servidor
    nombre_parse = nombre_parse.replaceAll('"', '\"');
    nombre_parse = nombre_parse.replaceAll("'", "\'");
    //console.log("desdps de", nombre_parse)
    return nombre_parse
}
export const Preload = ({ clase = "lds-dual-ring" }) => {
    return (
        <div className='container'>
            <div className='row'>
                <div xs={12} className="text-center">
                    <div className={clase}>   <div></div><div></div><div></div><div></div>    </div>
                </div>
            </div>
        </div>
    )
}
//export clipboard
export const ToolTip = ({ texto = "", tooltip = "" }) => {
    return (
        <>
            <span title={tooltip == "" ? texto : tooltip}>{texto}</span>
        </>
    )
}
export const ConsultaData = async (url, data = {}, method = 'GET', headers = {}) => {
    //console.log("wl token que estoy enviando", token, localStorage.getItem("token_web"))
    if (Object.keys(headers).length === 0) {
        headers = {
            'Authorization': localStorage.getItem("token_web"),
        }
    }
    const cuerpo = {
        method: method,
        headers: headers,
        body: JSON.stringify(data),
    }
    if (Object.keys(data).length === 0) {
        delete cuerpo.body
    }
    //console.log("mi url", Ruta + url)
    //console.log("mi ccc", cuerpo)
    return await fetch(Ruta + url, cuerpo)
        .then(response => response.json())
        .catch(error => {
            alert("Recargar lista o pagina")
        })
}
/*module.exports = { 
    experiments: {
        topLevelAwait: true,
    },
}*/
/*module.exports = {
    webpack: (config) => {
        // this will override the experiments
        config.experiments = { ...config.experiments, topLevelAwait: true };
        // this will just update topLevelAwait property of config.experiments
        config.experiments.topLevelAwait = true
        return config;
    },
};*/
export const distanciaEuclidiana = (a, b) => {
    const sumatoria = a.reduce((suma, valor, indice) => {
        const diferencia = valor - b[indice]
        return suma + diferencia * diferencia
    }, 0)
    return Math.sqrt(sumatoria)
}
export const isSession = async () => {
    //console.log("a", localStorage.getItem("token_web"))
    let exits = {}
    const cuerpo = {
        headers: {
            'Authorization': token,
        },
        body: JSON.stringify({
            "token": localStorage.getItem("token_web")
        }),
        method: "POST"
    }
    /*await fetch(`${Ruta}?/web/revisarSesion`, cuerpo)
        .then(response => response.json())
        .then(data => {
            exits = data
        })
    return exits*/
    //console.log("vot a consutlar")
    return await fetch(`${Ruta}?/web/revisarSesion`, cuerpo)
        .then(response => response.json())
        .catch(error => {
            //alert("Recargar lista o pagina")
            console.log("error en API", error)
        })
}
export default {
    Preload, ToolTip, ConsultaData, RutaLocal, Ruta, RutaProductos, ENDPOINT, porcentaje_igv, token, isSession,
    cantidad_decimales_venta, moneda_mostrar, TIPO_CAMBIO, calcularPrecioFinal, renderNumero, codeNombreProductoURL, decodeNombreProductoURL, distanciaEuclidiana
} 